export default class Sides {
  static left = "LEFT";
  static centre = "CENTRE";
  static right = "RIGHT";
}
